import { appConfig } from './index';

export interface NavLink {
  path: string;
  label: string;
}

/** Single source of truth for primary nav, shared by the masthead and footer. */
export function getNavLinks(): NavLink[] {
  return [
    ...(appConfig.features?.enableGames ? [{ path: '/games', label: 'Games' }] : []),
    ...(appConfig.features?.enablePredictions ? [{ path: '/predictions', label: 'Predictions' }] : []),
    ...(appConfig.features?.enableProps ? [{ path: '/props', label: 'Props' }] : []),
    ...(appConfig.features?.enableShop ? [{ path: '/shop', label: 'Shop' }] : []),
    { path: '/blog', label: 'Blog' },
    { path: '/glossary', label: 'Glossary' },
    { path: '/faq', label: 'FAQ' },
  ];
}
